// Dependancies

import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --background: #0B3C5D;
    --contentBackground:  #f9f9f9;
    --darkGrey: #1c1c1c;
    --headerMargin: 66px;
    --lightGrey: #eee;
    --white: #fff;
  }

  // custom theme colours
  .ion-color-darkest {
    --ion-color-base: var(--ion-color-darkest);
    --ion-color-base-rgb: var(--ion-color-darkest-rgb);
    --ion-color-contrast: var(--ion-color-darkest-contrast);
    --ion-color-contrast-rgb: var(--ion-color-darkest-contrast-rgb);
    --ion-color-shade: var(--ion-color-darkest-shade);
    --ion-color-tint: var(--ion-color-darkest-tint);
  }
  .ion-color-lightest {
    --ion-color-base: var(--ion-color-lightest);
    --ion-color-base-rgb: var(--ion-color-lightest-rgb);
    --ion-color-contrast: var(--ion-color-lightest-contrast);
    --ion-color-contrast-rgb: var(--ion-color-lightest-contrast-rgb);
    --ion-color-shade: var(--ion-color-lightest-shade);
    --ion-color-tint: var(--ion-color-lightest-tint);
  }
  .ion-color-calendar {
    --ion-color-base: var(--ion-color-calendar);
    --ion-color-base-rgb: var(--ion-color-calendar-rgb);
    --ion-color-contrast: var(--ion-color-calendar-contrast);
    --ion-color-contrast-rgb: var(--ion-color-calendar-contrast-rgb);
    --ion-color-shade: var(--ion-color-calendar-shade);
    --ion-color-tint: var(--ion-color-calendar-tint);
  }
  .ion-color-white {
    --ion-color-base: var(--ion-color-white);
    --ion-color-base-rgb: var(--ion-color-white-rgb);
    --ion-color-contrast: var(--ion-color-white-contrast);
    --ion-color-contrast-rgb: var(--ion-color-white-contrast-rgb);
    --ion-color-shade: var(--ion-color-white-shade);
    --ion-color-tint: var(--ion-color-white-tint);
  }
  .ion-color-black {
    --ion-color-base: var(--ion-color-black);
    --ion-color-base-rgb: var(--ion-color-black-rgb);
    --ion-color-contrast: var(--ion-color-black-contrast);
    --ion-color-contrast-rgb: var(--ion-color-black-contrast-rgb);
    --ion-color-shade: var(--ion-color-black-shade);
    --ion-color-tint: var(--ion-color-black-tint);
  }
  .ion-color-primarylight {
    --ion-color-base: var(--ion-color-primarylight);
    --ion-color-base-rgb: var(--ion-color-primarylight-rgb);
    --ion-color-contrast: var(--ion-color-primarylight-contrast);
    --ion-color-contrast-rgb: var(--ion-color-primarylight-contrast-rgb);
    --ion-color-shade: var(--ion-color-primarylight-shade);
    --ion-color-tint: var(--ion-color-primarylight-tint);
  }
  .ion-color-primarydark {
    --ion-color-base: var(--ion-color-primarydark);
    --ion-color-base-rgb: var(--ion-color-primarydark-rgb);
    --ion-color-contrast: var(--ion-color-primarydark-contrast);
    --ion-color-contrast-rgb: var(--ion-color-primarydark-contrast-rgb);
    --ion-color-shade: var(--ion-color-primarydark-shade);
    --ion-color-tint: var(--ion-color-primarydark-tint);
  }

  // Remove shadows from buttons
  ion-button {
    --box-shadow: none;
  }
  
  // Icons in avatar blocks
  ion-avatar {
    ion-icon {
      width: 100%;
      height: 100%;
    }
  }
  
  // FAB on Anrdoid and IOS
  .ios {
    // Hide FAB on ios
    .fab-button {
      display: none;
    }
  }
  .md {
    // Hide menu button on android
    .edit-button {
      display: none;
    }
  }
  
  // Skeleton animation styles
  .skeleton-text-animated {
    background-image: linear-gradient(
      to right,
      rgba(var(--ion-color-darkest-rgb), 0.067) 8%,
      rgba(var(--ion-color-darkest-rgb), 0.133) 18%,
      rgba(var(--ion-color-darkest-rgb), 0.067) 33%
    );
  }
  // Dark skeleton adjustments
  .dark {
    // skeleton animation styles
    .skeleton-text-animated {
      background-image: linear-gradient(
        to right,
        rgba(var(--ion-color-darkest-rgb), 0.067) 8%,
        rgba(var(--ion-color-darkest-rgb), 0.133) 18%,
        rgba(var(--ion-color-darkest-rgb), 0.067) 33%
      );
    }
  }
  
  // Dark action sheet adjustments
  .dark {
    // action sheet title
    .action-sheet-title {
      color: var(--ion-text-color);
    }
  }
  
  // Searchbar adjustments
  ion-searchbar {
    .searchbar-input.sc-ion-searchbar-md {
      box-shadow: none;
      border-radius: 0;
      background-color: var(--ion-color-lightest);
    }
  }
  
  // Card adjustments
  ion-card {
    box-shadow: none;
    --background: var(--ion-card-background);
    border-radius: 0;
    border: 1px solid var(--ion-card-border);
    margin-top: 3px;
    margin-bottom: 3px;
  
    // Adds some margin to the right of an ion-avitar that is located inside an ion-card
    > ion-avatar {
      margin-right: 1em;
      min-width: 40px;
      min-height: 40px;
    }
  }
  
  // Allows the ripple effect to flow onto the card header and item
  .ripple-card {
    ion-card-header,
    ion-card-content,
    ion-item,
    ion-list {
      --background: none;
      background: none;
    }
  }
  
  // Page adjustments
  .ion-page {
    background-color: var(--ion-color-lightest);
  }
  
  // Width modifiers
  .width-100pc {
    width: 100% !important;
  }
  
  // Custom checkbox labels
  ion-item.checkbox-pad {
    --padding-start: 0;
  
    ion-label.checkbox-pad {
      padding-left: 16px;
    }
  }
  
  // Flex utilities
  .flexed {
    display: flex !important;
    flex-direction: row;
    &.col {
      flex-direction: column;
    }
  }
  .flexed-fill {
    flex: 1 0 auto;
  }
  .flexed-fill-shrink {
    flex: 1 1 auto;
  }
  .flexed-fill-auto {
    flex: 1;
  }
  .flexed-center {
    align-items: center;
  }

  .hide {
    visibility: hidden;
    position: absolute;
  }
  
  // Form item styles
  ion-item.item-has-focus ion-label {
    color: var(--ion-color-primary) !important;
  }
  .dark {
    ion-item.item-has-focus ion-label {
      color: var(--ion-color-secondary) !important;
    }
  }
  
  /* login Glassmorphism */
  @font-face {
    font-family: 'Orbitron';
    font-style: normal;
    font-weight: bold;
    src: url('./assets/fonts/Orbitron-Bold.ttf'); 
  }

  // App title
  .app-title {
    color: var(--ion-color-primary);
    font-size: 3.5rem;
    margin-top: 4.5rem;
    display: flex;
    flex-direction: column;
    align-items: center; 
    font-family:  'Orbitron' !important;

    .logo {
      margin-bottom: 20px;
      --size: 70px;
      --border-radius: 8px;
      margin-right: auto;
      margin-left: auto;
    }
  }
`;

// USEFUL SNIPPETS

// --background: ${() => darken(0.02, cssVar('--ion-color-secondary') as string)};

// @media screen and (min-width: ${mediaScreenSize.tablet}) {
//   max-width: ${mediaScreenSize.tablet};
// }
